import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import OrderServiceRow from 'components/OrderServiceRow';

import { ServicesTable_items$key } from '__generated__/ServicesTable_items.graphql';

type Props = {
  items: ServicesTable_items$key;
};

const ServicesTable: FC<Props> = props => {
  const items = useFragment(
    graphql`
      fragment ServicesTable_items on OrderItem @relay(plural: true) {
        isService
        price

        ...OrderServiceRow_orderService
      }
    `,
    props.items
  );

  let totalPrice = 0;

  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Paslauga</TableCell>
            <TableCell align="center">Kaina asmeniui</TableCell>
            <TableCell align="center">Kiekis</TableCell>
            <TableCell align="center">Kaina viso</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {items.map((item, i) => {
            totalPrice += item.price;
            return <OrderServiceRow key={i} orderService={item} />;
          })}

          <TableRow>
            <TableCell colSpan={2} />
            <TableCell align="center">Viso</TableCell>
            <TableCell align="center">€{totalPrice}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ServicesTable;
